import { render } from "./impressum.vue?vue&type=template&id=68e8c707&scoped=true&ts=true"
import script from "./impressum.vue?vue&type=script&lang=ts"
export * from "./impressum.vue?vue&type=script&lang=ts"

import "./impressum.vue?vue&type=style&index=0&id=68e8c707&scoped=true&lang=scss"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e8c707"]])

export default __exports__